import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.jsx';
import './styles/01-haar.css';
import './styles/02-haar.css';
import './styles/03-haar.css';
import './styles/04-haar.css';
import './styles/05-ads.css';
import './styles/06-channels.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter><App /></BrowserRouter>
  </React.StrictMode>
);
